module.exports = __webpack_public_path__ + "img/cup.15b2ab08.svg";